import { isSupported, getAnalytics, logEvent, Analytics } from 'firebase/analytics'
import { initializeApp, getApps } from 'firebase/app'

let analytics: Analytics | null = null
isSupported().then((ok) => {
  if (ok && getApps().length) analytics = getAnalytics(getApps()[0])
}).catch(() => {})

export function track(event: string, params?: Record<string, any>) {
  try { if (analytics) logEvent(analytics, event, params) } catch {}
}
